/**
 * 提供 request 方法 “超时重试” 的能力
 * 1. 默认关闭（通过传入 hasCanRetry 参数控制）
 * 2. 超时重试一次
 * tips：部分（如登录）或非幂等的接口可能并不适合开启 ”超时重试“，根据业务进行选择
 * @method retry
 * @param {Function} func request 方法
 * @return {Function} 包装后的 request 方法
 */

import { isTimeoutError } from '@/base/error';
import { APP_RETRY_NETWORK_TIMEOUT } from '@/constants/';

const retry = func => options => {
  const { hasCanRetry = false } = options;
 
  if (!hasCanRetry) return func(options);
 
  options.timeout = options.timeout || APP_RETRY_NETWORK_TIMEOUT; // tips：“超时重试” 减少 timeout 以对齐正常接口
 
  return func(options).catch(err => {
    if (isTimeoutError(err)) {
      return func(options);
    }
 
    throw err;
  });
};

export default retry;
